import { useFormik } from "formik";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { useMutation } from "react-relay";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { changeEmailDialog_ChangeEmailMutation } from "@generated/changeEmailDialog_ChangeEmailMutation.graphql";
import { CHANGE_EMAIL_MUTATION } from "./change-email-dialog.graphql";
import { ChangeEmailDialogProps, FormState } from "./change-email-dialog.types";
import { PrimaryButton } from "../buttons/PrimaryButton";
import { DefaultTextFieldComponent } from "../form/DefaultTextInput.component";
import { ValidatedField } from "../form/ValidatedField.component";

export const ChangeEmailDialog = ({ isEmailRequired }: ChangeEmailDialogProps) => {
	const [isUpdateDialogVisible, setIsDialogVisible] = useState(isEmailRequired);

	const [changeEmail, isChanging] =
		useMutation<changeEmailDialog_ChangeEmailMutation>(CHANGE_EMAIL_MUTATION);
	const formik = useFormik<FormState>({
		initialValues: {
			email: "",
			email2: "",
		},
		validationSchema: Yup.object().shape({
			email: Yup.string()
				.email("Bitte geben Sie eine gültige E-Mail ein")
				.required("Das Feld E-Mail wird benötigt."),

			email2: Yup.string()
				.email("Bitte geben Sie eine gültige E-Mail ein")
				.required("Das Feld E-Mail wird benötigt.")
				.oneOf([Yup.ref("email")], "E-Mails müssen übereinstimmen."),
		}),
		onSubmit: (values) => {
			changeEmail({
				variables: {
					input: {
						email: values.email,
					},
				},
				onCompleted: () => {
					toast("E-Mail erfolgreich geändert.", { type: "success" });
					formik.resetForm();
					setIsDialogVisible(false);
				},
			});
		},
	});
	return (
		<Dialog
			className="w-12 md:w-4 lg:w-4"
			visible={isUpdateDialogVisible}
			closeOnEscape={true}
			closable={true}
			header={<p>Email Aktualisierung erforderlich</p>}
			onHide={() => {
				setIsDialogVisible(false);
			}}
			showHeader={true}
		>
			<p className="mb-4">
				Die aktuell hinterlegte E-Mail-Adresse ist nicht mehr gültig. Bitte aktualisieren Sie Ihre
				E-Mail-Adresse, um den Zugriff auf Ihr Konto sicherzustellen. Ab sofort müssen Sie die neue
				E-Mail-Adresse auch für den Login verwenden.
			</p>
			<form onSubmit={formik.handleSubmit} className="p-fluid">
				<ValidatedField<FormState, string>
					name={"email"}
					label={"Neue E-Mail"}
					iconClass={"pi-envelope"}
					required={true}
					formikConfig={formik}
					component={DefaultTextFieldComponent}
				/>
				<ValidatedField<FormState, string>
					name={"email2"}
					label={"E-Mail (wiederholen)"}
					iconClass={"pi-envelope"}
					required={true}
					formikConfig={formik}
					component={DefaultTextFieldComponent}
				/>
				<PrimaryButton disabled={isChanging} label={"Speichern"} />
			</form>
		</Dialog>
	);
};
